import _ from "lodash"

import { CategoryId } from "shared/hubrise/ids"
import { ICategoryOrProduct, ICategory } from "shared/hubrise/models"
import * as Category from "shared/hubrise/utils/Category"

import type { Change, OperationContext } from "./types"

export type CategoryOperations = {
  add(insertAfter: ICategoryOrProduct | undefined, values: Partial<ICategory>): ICategory
  delete(category: ICategory): void
  move(category: ICategory, newParentCategoryId: CategoryId | null, insertAfterCategoryId: CategoryId | null): void
  update<T extends keyof ICategory>(
    id: CategoryId,
    fieldName: T,
    value: ICategory[T],
    options?: { collapse?: boolean },
  ): void
}

export default ({ catalog, pushState }: OperationContext): CategoryOperations => ({
  add(insertAfter, values) {
    const { newCatalog, category } = Category.add(catalog, insertAfter, values)
    pushState(newCatalog, { model: "category", operation: "add" })
    return category
  },

  delete(category) {
    const newCatalog = Category.doDelete(catalog, category)
    pushState(newCatalog, { model: "category", operation: "delete", id: category.id })
  },

  move(category, ...args) {
    const newCatalog = Category.move(catalog, category, ...args)
    const change: Change = { model: "category", operation: "move", id: category.id }
    pushState(newCatalog, change, (previousChange) => _.isEqual(previousChange, change))
  },

  update(id, fieldName, value, { collapse = true } = {}) {
    const newCatalog = Category.update(catalog, id, fieldName, value)
    const change: Change = {
      model: "category",
      id,
      operation: "update",
      fieldName,
    }
    pushState(newCatalog, change, (previousChange) => collapse && _.isEqual(previousChange, change))
  },
})
